"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _grapesjsReact = require("grapesjs-react");
require("grapesjs/dist/css/grapes.min.css");
var _grapesjsPresetWebpage = _interopRequireDefault(require("grapesjs-preset-webpage"));
var _grapesjsBlocksBasic = _interopRequireDefault(require("grapesjs-blocks-basic"));
var _reactNative = require("react-native");
var _grapesjs = _interopRequireDefault(require("grapesjs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var GrapesEditor2 = function GrapesEditor2(_ref) {
  var available_variables = _ref.available_variables,
    html = _ref.html,
    updateHtml = _ref.updateHtml,
    setObj = _ref.setObj;
  var initEditor = (0, _react.useCallback)(function () {
    var editor = _grapesjs["default"].init({
      container: '#gjs',
      height: '600px',
      width: 'auto',
      storageManager: false,
      plugins: [_grapesjsPresetWebpage["default"], _grapesjsBlocksBasic["default"]],
      components: html
    });
    var onChangesCount = function onChangesCount() {
      updateHtml(editor.getHtml());
    };
    editor.on('change:changesCount', onChangesCount);
    return function () {
      editor.off('change:changesCount', onChangesCount);
      editor.destroy();
    };
  }, [html, updateHtml]);
  (0, _react.useEffect)(function () {
    var cleanup = initEditor();
    return cleanup;
  }, [initEditor]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "gjs"
  });
};
var _default = exports["default"] = GrapesEditor2;